module.exports = __webpack_public_path__ + "static/media/reciepts.72474bd6.svg";